import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FW from "../../config/word.json";
import FS from "../../config/sentence.json";
import { login } from "../../api/project";
import { clearSession, hasValidSession } from "../../utils/auth";
import logo from "./DX_Jankatsu_Master_Logo.svg";
import "./Login.css";

function Login() {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (hasValidSession()) navigate("/home", { replace: true });
    else clearSession();
  }, [navigate]);

  async function onFormSubmit(event) {
    event.preventDefault();
    if (submitting) return;
    setErrorMessage("");
    if (userId.length < 5) return setErrorMessage(FS.F_S_MSG1);
    if (password.length < 6) return setErrorMessage(FS.F_S_MSG2);

    setSubmitting(true);
    try {
      const res = await login({ userId, password });
      if (res?.code !== 200 || !res?.data?.token || !res?.data?.user) {
        setErrorMessage(res?.message || "ユーザーIDまたはパスワードをご確認ください。");
        return;
      }
      const { token, user } = res.data;
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("userId", user.userId ?? "");
      sessionStorage.setItem("userFlg", user.userFlg ?? "");
      sessionStorage.setItem("daikai_title2", user.searchKeyWord ?? "");
      sessionStorage.setItem("ad_banner_id", user.adId ?? "");
      sessionStorage.setItem("ad_banner_name", user.adName ?? "");
      navigate("/home", { replace: true });
    } catch (err) {
      setErrorMessage(err?.message || "ログインに失敗しました。時間をおいて再度お試しください。");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="dx-login-page">
      <div className="dx-login-orb dx-login-orb-left" aria-hidden="true" />
      <div className="dx-login-orb dx-login-orb-right" aria-hidden="true" />
      <section className="dx-login-wrap" aria-label="ログイン">
        <div className="dx-login-brand"><img src={logo} alt="DX 雀活マスター" /></div>
        <div className="dx-login-card">
          <div className="dx-login-heading">
            <h1>{FW.F_W_LOGIN_T1 || "ログイン"}</h1>
            <p>管理システムへようこそ</p>
          </div>
          <form onSubmit={onFormSubmit} className="dx-login-form">
            <label htmlFor="dx-user-id">ユーザーID</label>
            <input id="dx-user-id" name="username" value={userId} onChange={(e) => { setUserId(e.target.value); setErrorMessage(""); }} maxLength={30} placeholder={FW.F_W_SYS_N} autoComplete="username" required aria-label="userId" />
            <label htmlFor="dx-password">パスワード</label>
            <div className="dx-login-password">
              <input id="dx-password" name="password" value={password} onChange={(e) => { setPassword(e.target.value); setErrorMessage(""); }} type={showPassword ? "text" : "password"} maxLength={30} placeholder={FW.F_W_SYS_P} autoComplete="current-password" required aria-label="password" />
              <button type="button" className="dx-password-toggle" aria-label={showPassword ? "パスワードを隠す" : "パスワードを表示"} aria-pressed={showPassword} onClick={() => setShowPassword((v) => !v)}>{showPassword ? "非表示" : "表示"}</button>
            </div>
            {errorMessage && <p role="alert" className="dx-login-error">{errorMessage}</p>}
            <button type="submit" className="dx-login-submit" disabled={submitting} aria-label="submit">{submitting ? "ログイン中..." : FW.F_W_LOGIN_LOGIN || "ログイン"}<span aria-hidden="true">→</span></button>
          </form>
        </div>
        <div className="dx-login-footer">DX 雀活マスター · Management System</div>
      </section>
    </main>
  );
}

export default Login;
